import { render } from "./FormDrawer.vue?vue&type=template&id=fa55cddc&scoped=true"
import script from "./FormDrawer.vue?vue&type=script&lang=js"
export * from "./FormDrawer.vue?vue&type=script&lang=js"

import "./FormDrawer.vue?vue&type=style&index=0&id=fa55cddc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa55cddc"]])

export default __exports__